export default defineNuxtRouteMiddleware(() => {
	const store = useAdminAuthStore()
	const localePath = useLocalePath()
	if (!store.state.user) {
		return navigateTo(localePath('/panel/login'))
	} else if (!store.isAdmin) {
		return navigateTo(localePath('/panel/login'))
	}
})
